module.exports = __webpack_public_path__ + "img/ps.3d86c411.png";